var React = require('react');

function MapsIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 0.171875C2.74447 0.171875 0.920232 1.99611 0.920232 4.25164C0.920232 7.31147 5 11.8284 5 11.8284C5 11.8284 9.07977 7.31147 9.07977 4.25164C9.07977 1.99611 7.25553 0.171875 5 0.171875ZM5 5.7087C4.1957 5.7087 3.54294 5.05594 3.54294 4.25164C3.54294 3.44735 4.1957 2.79458 5 2.79458C5.8043 2.79458 6.45706 3.44735 6.45706 4.25164C6.45706 5.05594 5.8043 5.7087 5 5.7087Z","fill":"#337179"}));
}

MapsIcon.defaultProps = {"width":"10","height":"12","viewBox":"0 0 10 12","fill":"none"};

module.exports = MapsIcon;

MapsIcon.default = MapsIcon;
